import { color as foundationColor, size } from '../foundation';
import { color, effects } from '../semantic';

const { error, info, neutral, success, warning, yellow } = foundationColor;

export const tag = {
  color: {
    badge: {  // display read-only attributes such as status, color-coded for semantic meaning
      bg: {
        default: {  // default badge color used on white and light grey backgrounds
          neutral: neutral[300],
          info: info[100],
          success: success[100],
          caution: yellow[100],
          warning: warning[100],
          error: error[100],
        },
        bold: {   // bold badge color used on colored backgrounds (active)
          neutral: neutral[400],
          info: info[200],
          success: success[200],
          caution: yellow[200],
          warning: warning[200],
          error: error[200],
        },
      },
      text: {
        default: {
          neutral: neutral[800],
          info: info[800],
          success: success[800],
          caution: yellow[800],
          warning: warning[800],
          error: error[800],
        },
        bold: {
          caution: yellow[800], // darker text for accessibility on bold yellow background
        },
      },
    },
    chip: {   // display filter values, may be read-only or removable
      default: {
        bg: neutral[300],
        button: neutral[600],
      },
      error: {
        label: error[500],
      },
    },
  },
  size: {
    badge: {
      height: {
        sm: size[350],  
        md: size[400],  
        lg: size[500],  
      },
      minWidth: {
        sm: size[600],
        md: size[700],
        lg: size[800],
      },
    },
    chip: {
      height: {
        sm: size[350],  
        md: size[400],  
        lg: size[500],  
      },
      minWidth: {
        sm: size[600],
        md: size[700],
        lg: size[800],
      },
    },
  },
};

export default tag;